export default "__VITE_ASSET__FVPEMTII__"